import React from 'react';
import { Button, RobbieMark } from '../../components/ui';
import { displayRfqId } from '../../utils/rfqIdentity';

/**
 * Full-screen wizard states outside the chrome: loading, honest not-found,
 * and load errors — all in Robbie's voice (first person, consequence, next
 * action), never fabricated content.
 */
const Shell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="flex h-app items-center justify-center bg-canvas p-s6 font-sans">
    <div className="flex w-full max-w-[420px] flex-col items-center gap-s5 text-center">{children}</div>
  </div>
);

export const WizardLoading: React.FC<{ message?: string }> = ({ message }) => (
  <Shell>
    <RobbieMark size="lg" state="thinking" aria-label="Robbie is loading this RFQ" />
    <p className="m-0 text-body-md font-semibold text-ink">{message || 'Loading your RFQ…'}</p>
  </Shell>
);

export const WizardNotFound: React.FC<{ rfqId: string; onBack: () => void }> = ({ rfqId, onBack }) => (
  <Shell>
    <RobbieMark size="lg" aria-label="Robbie" />
    <h2 className="m-0 text-page-title text-ink">I can't find that RFQ</h2>
    <p className="m-0 text-body-md text-ink-secondary">
      I looked for <span className="font-semibold text-ink">{displayRfqId(rfqId)}</span> in your workspace, but it isn't
      there — the link may be stale, or the RFQ was removed. Head back to the dashboard and I'll show you
      everything that's live.
    </p>
    <Button onClick={onBack}>Back to dashboard</Button>
  </Shell>
);

export const WizardError: React.FC<{ message?: string; onBack: () => void }> = ({ message, onBack }) => (
  <Shell>
    <RobbieMark size="lg" aria-label="Robbie" />
    <h2 className="m-0 text-page-title text-ink">I couldn't load this RFQ</h2>
    <p className="m-0 text-body-md text-ink-secondary">
      {message || 'Something went wrong on my side.'} Try again from the dashboard — if it keeps happening,
      tell me and I'll dig into it.
    </p>
    <Button onClick={onBack}>Back to dashboard</Button>
  </Shell>
);
